<div class="snack-container d-flex align-items-center justify-content-between">
   <div class="d-flex align-items-center gap-2">
    <app-customicon *ngIf="getIcon" [name]="getIcon"></app-customicon>
    <span class="m-3">{{data.message}}</span>
   </div>
   <app-customicon *ngIf="getActionIcon" [name]="getActionIcon" (click)="close()"></app-customicon>
    <!-- <mat-icon *ngIf="data.action" (click)="close()">close</mat-icon> -->
</div>